export default {
    SET_MODAL_GENERATE_BALANCE_DATA: 'setModalGenerateBalanceData',
    SET_MODAL_GENERATE_BALANCE_ERRORS: 'setModalGenerateBalanceErrors'
}